import React, { type ReactNode } from "react"
import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import clsx from "clsx"
import { useObserver } from "../../../hooks"

import Img from "./Img"

import * as styles from "./banner.module.scss"
import {
  handleClickBanner,
  handleClickStickyBtn,
} from "../../../helpers/WatcherDL/utils/handleClickBanner"

const defaultTitle = <>Рассрочка до&nbsp;24&nbsp;месяцев</>

const defaultDesc = "по карте «Халва»"

type BannerProps = {
  buttonText?: string
  orderNum?: string
  title?: ReactNode
  description?: ReactNode
  variantStyle?: "getHalva"
}

export function Banner({
  buttonText = "Оформить карту",
  orderNum,
  title = defaultTitle,
  description = defaultDesc,
  variantStyle,
}: BannerProps) {
  const isVisible = useObserver(["app", "calculatorCard", "reviewCard", "moreBenefits", "formPkw"])

  return (
    <>
      <section
        className={clsx(styles.section, variantStyle && styles[variantStyle])}
        data-exclude={orderNum}
      >
        <Container className={styles.container}>
          <div className={styles.secondContainer}>
            <Img alt="bg image" className={styles.img} />
            <div className={styles.text}>
              <h1>{title}</h1>
              <div>{description}</div>
            </div>
            <Button className={styles.btn} onClick={() => handleClickBanner(buttonText, title)}>
              {buttonText}
            </Button>
          </div>
        </Container>
      </section>
      <div className={clsx(styles.btnBlock, { [styles.hideMobBlock]: isVisible })}>
        <Container>
          <Button onClick={handleClickStickyBtn} className={styles.mobBtn}>
            {buttonText}
          </Button>
        </Container>
      </div>
    </>
  )
}
